import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonusTotalValue, bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonuses" className="defer-paint w-full scroll-mt-16 bg-ivory py-10 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-15" data-mp="gxq61mpu70ny">
      <div className="mx-auto max-w-5xl px-6" data-id="element-16" data-mp="qu2xsf1tn4g2">
        <SectionHeading eyebrow="🎁 The abundance bonus bundle" eyebrowTone="lime" title={<span id="bonuses-heading" data-id="element-18" data-mp="14sj4i5zoouy7">
              7 strategic bonuses.{' '}
              <span className="text-lime-ink" data-id="element-19" data-mp="zv14j53n9q2c">
                {bonusTotalValue} value — yours free.
              </span>
            </span>} lead="The volumes solve what to teach. These bonuses solve everything around it: the drill you need in ten seconds, the words that fix an error, and the plan you write in five minutes." data-id="element-17" data-mp="qs8boxetd6ae" />

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="1nkvgzlk1xcm2">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col rounded-2xl border border-line bg-shell p-6 shadow-soft ${index === 0 || index === bonuses.length - 1 ? 'lg:col-span-2' : ''}`} data-id="element-21" data-mp="1jjs334lkdqnh" data-mpi={index}>
              <div className="flex items-start justify-between gap-4" data-id="element-22" data-mp="3tsow5sbvugu7">
                <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-navy" data-id="element-23" data-mp="2lcoq50sxhrh">
                  Bonus {bonus.number}
                </p>
                <span className="rounded-full bg-lime-soft px-2.5 py-1 font-display text-[11px] font-bold text-lime-ink" data-id="element-24" data-mp="7icl1o7un65e">
                  {bonus.value}
                </span>
              </div>

              <h3 className="mt-3 font-display text-base font-bold leading-snug text-ink" data-id="element-25" data-mp="gj0z2ix8t6ia">
                {bonus.title}
              </h3>
              <p className="mt-auto pt-3 font-sans text-[0.85rem] leading-relaxed text-stone" data-id="element-26" data-mp="qbghfhcgbx3p">
                {bonus.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}